export enum PeppolStatusFilter {
  All = 'all',
  Active = 'active',
  ActiveSendOnly = 'active_send_only',
  Inactive = 'inactive',
  UnRegistered = 'unregistered',
  VerificationRequired = 'verification_required',
  Pending = 'pending',
  RegisteredElsewhere = 'registered_elsewhere',
  Unknown = 'unknown',
}
